import { Grid, makeStyles } from '@material-ui/core'
import { CopilotEngagementCategories } from 'consts/copilotControlConsts'
import React, { useMemo } from 'react'

const useStyles = makeStyles(() => ({
  root: {
    height: 20,
    '&>:first-child': {
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10
    },
    '&>:last-child': {
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10
    }
  }
}))

const ScoresBar = ({ values, scoreOptions = {} }) => {
  const classes = useStyles()

  const getWidthPercentage = (value, total) => (total === 0 ? 0 : (value / total) * 100)

  const scoresTotal = Object.values(values).reduce((acc, value) => acc + value, 0)

  const widths = useMemo(() => {
    return {
      [CopilotEngagementCategories.Negative]: getWidthPercentage(values.negative, scoresTotal),
      [CopilotEngagementCategories.Neutral]: getWidthPercentage(values.neutral, scoresTotal),
      [CopilotEngagementCategories.Positive]: getWidthPercentage(values.positive, scoresTotal)
    }
  }, [values, scoresTotal])

  return (
    <Grid container className={classes.root}>
      {values.negative ? (
        <Grid
          item
          style={{
            width: `${widths.negative}%`,
            backgroundColor: scoreOptions.negative.strokeColor
          }}
        />
      ) : null}
      {values.neutral ? (
        <Grid
          item
          style={{
            width: `${widths.neutral}%`,
            backgroundColor: scoreOptions.neutral.strokeColor
          }}
        />
      ) : null}
      {values.positive ? (
        <Grid
          item
          style={{
            width: `${widths.positive}%`,
            backgroundColor: scoreOptions.positive.strokeColor
          }}
        />
      ) : null}
    </Grid>
  )
}

export default ScoresBar
